export default function canNav({ to, next, store }) {
  const dashboardQuery = { path: "/dashboard" };

  const reqPermission = to.meta.requirePermission;
  if (reqPermission) {
    if (store.getters.hasNavPermission(reqPermission)) {
      next();
    } else {
      next(dashboardQuery);
    }
  } else {
    next();
  }
}
